// extracted by mini-css-extract-plugin
export default {"Loader":"Loader_Loader__S4nlO","Inline":"Loader_Inline__YY5iV","FullWidth":"Loader_FullWidth__GszPP","Show":"Loader_Show__con80","Hide":"Loader_Hide__gc-0Q"};